/* product-paardenafsluiting-calculator.js — Prindal-Hout (v1)

   Rekenprincipe (zie ook de comment bovenaan het .liquid-bestand):
   - Elk recht stuk van de afsluiting wordt opgedeeld in "spans" van exact
     liggerLengthM meter (de fysieke lengte van 1 ligger-plank). Het aantal
     spans per stuk = Math.ceil(stuklengte / liggerLengthM) — net als de
     rollen-berekening in de hek-calculator, maar hier bepaalt de PRODUCT-
     lengte zelf de tussenafstand (er is geen aparte, door de klant te
     kiezen tussenafstand).
   - liggers nodig = spans * aantalLiggers (per stuk, opgeteld over alle
     stukken).
   - tussenpalen (interne palen binnen een stuk) = spans - 1 per stuk.
   - Op elk hoekpunt van de vorm: een "hoekpaal" (of, als die niet gekoppeld
     is aan het metaobject, 2x "tussenpaal") — behalve op een echt open
     uiteinde (niet-gesloten vorm), waar een "eindpaal" komt (of, als die
     niet gekoppeld is, 1x "tussenpaal").
   - Poorten: meerdere tegelijk mogelijk. Elke poort "consumeert" een stuk
     van een zijde (type+afmeting+positie), en het stuk wordt daar virtueel
     opgesplitst in de stukken vóór/na de poort, die elk apart hun eigen
     spans/tussenpalen krijgen. Een poort die exact op een bestaand
     hoekpunt van de zijde begint/eindigt, "absorbeert" dat hoekpunt (geen
     extra hoek-/eindpaal nodig daar — de poort-variant wordt verondersteld
     haar eigen palen te bevatten).
*/
window.PrindalPaardCalc = (function () {
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var EPS = 0.005;

  function money(cents) {
    return '\u20AC ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function init(rootId, dataScriptId) {
    var root = document.getElementById(rootId);
    var dataScript = document.getElementById(dataScriptId);
    if (!root || !dataScript) return;

    var data;
    try {
      data = JSON.parse(dataScript.textContent);
    } catch (e) {
      console.error('Paardenafsluiting calc: kon data niet lezen', e);
      return;
    }
    var t = data.t || {};
    var active = data.fence;
    if (!active) return;

    // ---------------------------------------------------------------
    // Root-markup — linkerhelft (tekst/keuzes) + rechterhelft (tekening)
    // ---------------------------------------------------------------
    root.innerHTML =
      '<p class="pk-calc__title"></p>' +
      '<p class="pk-calc__intro"></p>' +

      '<div class="pk-calc__layout">' +
        '<div class="pk-calc__col-left">' +

          '<div class="pk-calc__block">' +
            '<p class="pk-calc__label pk-calc__label--subtitle" data-pk-mode-label></p>' +
            '<div class="pk-calc__shape-toggle" data-pk-mode-toggle>' +
              '<button type="button" class="pk-calc__shape-btn is-active" data-mode="rechthoek"></button>' +
              '<button type="button" class="pk-calc__shape-btn" data-mode="vrije"></button>' +
              '<button type="button" class="pk-calc__shape-btn" data-mode="lopende"></button>' +
            '</div>' +
          '</div>' +

          '<div data-pk-mode-rechthoek class="pk-calc__block">' +
            '<div class="pk-calc__inline-fields">' +
              '<div class="pk-calc__field pk-calc__field--num"><label data-pk-rect-width-label></label><input type="number" min="0" step="0.1" data-pk-rect-width></div>' +
              '<div class="pk-calc__field pk-calc__field--num"><label data-pk-rect-length-label></label><input type="number" min="0" step="0.1" data-pk-rect-length></div>' +
            '</div>' +
          '</div>' +

          '<div data-pk-mode-vrije class="pk-calc__block" hidden>' +
            '<table class="pk-calc__table"><thead><tr><th></th><th data-pk-th-length></th><th data-pk-th-angle></th><th></th></tr></thead>' +
            '<tbody data-pk-segments-list></tbody></table>' +
            '<div class="pk-calc__inline-fields">' +
              '<button type="button" class="pk-calc__add-segment-btn" data-pk-add-segment></button>' +
              '<button type="button" class="pk-calc__add-segment-btn" data-pk-close-loop></button>' +
            '</div>' +
          '</div>' +

          '<div data-pk-mode-lopende class="pk-calc__block" hidden>' +
            '<div class="pk-calc__inline-fields">' +
              '<div class="pk-calc__field pk-calc__field--num"><label data-pk-linear-length-label></label><input type="number" min="0" step="0.1" data-pk-linear-length></div>' +
            '</div>' +
            '<div class="pk-calc__field" data-pk-linear-corners-wrap hidden>' +
              '<label data-pk-corners-label></label>' +
              '<input type="number" min="0" step="1" value="0" data-pk-linear-corners style="width:90px;">' +
            '</div>' +
          '</div>' +

          '<div class="pk-calc__block" data-pk-gate-question hidden>' +
            '<p class="pk-calc__label pk-calc__label--subtitle" data-pk-gate-label></p>' +
            '<div class="pk-calc__toggle" data-pk-gate-toggle>' +
              '<button type="button" class="pk-calc__toggle-btn" data-val="yes"></button>' +
              '<button type="button" class="pk-calc__toggle-btn is-active" data-val="no"></button>' +
            '</div>' +
          '</div>' +

          '<div data-pk-gates-wrap hidden>' +
            '<div data-pk-gates-list></div>' +
            '<button type="button" class="pk-calc__add-gate-btn" data-pk-add-gate></button>' +
          '</div>' +

          '<div class="pk-calc__results" data-pk-results hidden>' +
            '<div class="pk-calc__row-group" data-pk-breakdown></div>' +
            '<div class="pk-calc__row-group pk-calc__row-group--pro" data-pk-pro-breakdown hidden></div>' +
            '<button type="button" class="pk-calc__button" data-pk-add-to-cart disabled></button>' +
            '<p class="pk-calc__cart-msg" data-pk-cart-msg></p>' +
          '</div>' +

        '</div>' +

        '<div class="pk-calc__col-right">' +
          '<div class="pk-calc__instructions-row" data-pk-instructions-row hidden>' +
            '<a class="pk-calc__instructions-btn" data-pk-instructions-link target="_blank" rel="noopener">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><line x1="10" y1="9" x2="8" y2="9"></line></svg>' +
              '<span data-pk-instructions-label></span>' +
            '</a>' +
          '</div>' +
          '<div class="pk-calc__drawing" data-pk-drawing-wrap>' +
            '<svg viewBox="0 0 600 320" data-pk-drawing-svg>' +
              '<g data-pk-drawing-content></g>' +
              '<text x="300" y="312" text-anchor="middle" class="pk-calc__drawing-note" data-pk-drawing-note opacity="0"></text>' +
            '</svg>' +
          '</div>' +
          '<p class="pk-calc__drawing-placeholder" data-pk-drawing-placeholder hidden></p>' +
        '</div>' +
      '</div>';

    // ---------------------------------------------------------------
    // Labels
    // ---------------------------------------------------------------
    root.querySelector('.pk-calc__title').textContent = t.title || '';
    root.querySelector('.pk-calc__intro').textContent = t.intro || '';
    root.querySelector('[data-pk-mode-label]').textContent = t.modeLabel || '';
    root.querySelector('[data-mode="rechthoek"]').textContent = t.modeRect || '';
    root.querySelector('[data-mode="vrije"]').textContent = t.modeFree || '';
    root.querySelector('[data-mode="lopende"]').textContent = t.modeLinear || '';
    root.querySelector('[data-pk-rect-width-label]').textContent = t.width || '';
    root.querySelector('[data-pk-rect-length-label]').textContent = t.lengthField || '';
    root.querySelector('[data-pk-th-length]').textContent = t.length || '';
    root.querySelector('[data-pk-th-angle]').textContent = t.angle || '';
    root.querySelector('[data-pk-add-segment]').textContent = t.addSegment || '';
    root.querySelector('[data-pk-close-loop]').textContent = t.closeLoop || '';
    root.querySelector('[data-pk-linear-length-label]').textContent = t.linearLength || '';
    root.querySelector('[data-pk-corners-label]').textContent = t.cornersLabel || '';
    root.querySelector('[data-pk-gate-label]').textContent = t.gateLabel || '';
    root.querySelector('[data-pk-add-gate]').textContent = t.addGate || '';
    root.querySelectorAll('[data-val="yes"]').forEach(function (b) { b.textContent = t.yes || 'Ja'; });
    root.querySelectorAll('[data-val="no"]').forEach(function (b) { b.textContent = t.no || 'Nee'; });
    var drawingNote = root.querySelector('[data-pk-drawing-note]');
    drawingNote.textContent = t.schematicNote || '';
    var drawingPlaceholder = root.querySelector('[data-pk-drawing-placeholder]');

    // Instructies-knop (optioneel, ingesteld via de theme editor)
    var instructionsRow = root.querySelector('[data-pk-instructions-row]');
    var instructionsLink = root.querySelector('[data-pk-instructions-link]');
    var instructionsLabelEl = root.querySelector('[data-pk-instructions-label]');
    if (data.instructionsUrl) {
      instructionsLink.href = data.instructionsUrl;
      instructionsLabelEl.textContent = data.instructionsLabel || '';
      instructionsRow.hidden = false;
    }

    // ---------------------------------------------------------------
    // Element refs
    // ---------------------------------------------------------------
    var modeButtons = root.querySelectorAll('[data-pk-mode-toggle] [data-mode]');
    var modeRechthoekEl = root.querySelector('[data-pk-mode-rechthoek]');
    var modeVrijeEl = root.querySelector('[data-pk-mode-vrije]');
    var modeLopendeEl = root.querySelector('[data-pk-mode-lopende]');

    var rectWidthInput = root.querySelector('[data-pk-rect-width]');
    var rectLengthInput = root.querySelector('[data-pk-rect-length]');

    var segmentsList = root.querySelector('[data-pk-segments-list]');
    var addSegmentBtn = root.querySelector('[data-pk-add-segment]');
    var closeLoopBtn = root.querySelector('[data-pk-close-loop]');
    var closeLoopOn = false;

    var linearLengthInput = root.querySelector('[data-pk-linear-length]');
    var linearCornersWrap = root.querySelector('[data-pk-linear-corners-wrap]');
    var linearCornersInput = root.querySelector('[data-pk-linear-corners]');

    var drawingWrap = root.querySelector('[data-pk-drawing-wrap]');
    var drawingContent = root.querySelector('[data-pk-drawing-content]');

    var gateQuestion = root.querySelector('[data-pk-gate-question]');
    var gateToggleButtons = root.querySelectorAll('[data-pk-gate-toggle] [data-val]');
    var gatesWrap = root.querySelector('[data-pk-gates-wrap]');
    var gatesListEl = root.querySelector('[data-pk-gates-list]');
    var addGateBtn = root.querySelector('[data-pk-add-gate]');

    var resultsEl = root.querySelector('[data-pk-results]');
    var breakdownEl = root.querySelector('[data-pk-breakdown]');
    var proBreakdownEl = root.querySelector('[data-pk-pro-breakdown]');
    var addToCartBtn = root.querySelector('[data-pk-add-to-cart]');
    addToCartBtn.textContent = t.addToCart || '';
    var cartMsg = root.querySelector('[data-pk-cart-msg]');

    // Bundel-blokken (sloten/palen voor een poort) staan als losse, van
    // tevoren gerenderde blokken naast de calculator — 1 per uniek
    // poort-product, altijd verborgen tenzij dat product actief gekozen is
    // in minstens 1 poort-kaart.
    var gateBundlesWrap = document.getElementById(rootId + '-gate-bundles');
    if (gateBundlesWrap) {
      var colRightEl = root.querySelector('.pk-calc__col-right');
      if (colRightEl) colRightEl.appendChild(gateBundlesWrap);
    }
    function updateGateBundles() {
      if (!gateBundlesWrap) return;
      var activeProductIds = {};
      gates.forEach(function (g) { if (g.item && g.item.productId) activeProductIds[g.item.productId] = true; });
      gateBundlesWrap.querySelectorAll('[data-pk-gate-bundle-product]').forEach(function (el) {
        var pid = el.getAttribute('data-pk-gate-bundle-product');
        el.hidden = !activeProductIds[pid];
      });
    }

    // ---------------------------------------------------------------
    // State
    // ---------------------------------------------------------------
    var state = { mode: 'rechthoek', polesOn: true, gateOn: false };
    var segments = [];
    var segIdCounter = 0;
    var gates = []; // { id, groupIndex, item, segIdx, dist, els:{...} }
    var gateIdCounter = 0;
    var lastCalc = null;

    function liggerLengthM() {
      return (active.liggerLengthCm || 0) / 100;
    }

    // ---------------------------------------------------------------
    // Vrije-vorm segmenten (identiek principe aan de hek-calculator)
    // ---------------------------------------------------------------
    function addSegment() {
      segIdCounter++;
      var isFirst = segments.length === 0;
      var tr = document.createElement('tr');
      tr.innerHTML =
        '<td class="pk-calc__seg-name"></td>' +
        '<td><input type="number" min="0" step="0.1" inputmode="decimal" data-seg-length></td>' +
        '<td><input type="number" step="1" inputmode="decimal" data-seg-angle value="' + (isFirst ? '0' : '90') + '"' + (isFirst ? ' disabled' : '') + '></td>' +
        '<td><button type="button" class="pk-calc__seg-remove">\u00D7</button></td>';
      segmentsList.appendChild(tr);

      var seg = {
        id: segIdCounter, rowEl: tr,
        nameEl: tr.querySelector('.pk-calc__seg-name'),
        lengthInput: tr.querySelector('[data-seg-length]'),
        angleInput: tr.querySelector('[data-seg-angle]'),
        removeBtn: tr.querySelector('.pk-calc__seg-remove')
      };
      seg.removeBtn.setAttribute('aria-label', t.removeSegment || '');
      seg.lengthInput.addEventListener('input', function () { refreshAllGateSegmentOptions(); recalc(); });
      seg.angleInput.addEventListener('input', recalc);
      seg.removeBtn.addEventListener('click', function () { removeSegment(seg); });

      segments.push(seg);
      renumberSegments();
      return seg;
    }
    function removeSegment(seg) {
      if (segments.length <= 1) return;
      var idx = segments.indexOf(seg);
      segments.splice(idx, 1);
      seg.rowEl.parentNode.removeChild(seg.rowEl);
      if (segments.length) { segments[0].angleInput.value = '0'; segments[0].angleInput.disabled = true; }
      renumberSegments();
      refreshAllGateSegmentOptions();
      recalc();
    }
    function renumberSegments() {
      segments.forEach(function (s, i) {
        s.nameEl.textContent = (t.segment || 'Segment') + ' ' + (i + 1);
        s.removeBtn.hidden = segments.length <= 1;
      });
    }
    addSegmentBtn.addEventListener('click', function () { addSegment(); refreshAllGateSegmentOptions(); recalc(); });
    closeLoopBtn.addEventListener('click', function () {
      closeLoopOn = !closeLoopOn;
      closeLoopBtn.classList.toggle('is-active', closeLoopOn);
      refreshAllGateSegmentOptions();
      recalc();
    });

    // ---------------------------------------------------------------
    // Mode-toggle
    // ---------------------------------------------------------------
    modeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.mode = btn.getAttribute('data-mode');
        modeButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        modeRechthoekEl.hidden = state.mode !== 'rechthoek';
        modeVrijeEl.hidden = state.mode !== 'vrije';
        modeLopendeEl.hidden = state.mode !== 'lopende';
        linearCornersWrap.hidden = state.mode !== 'lopende';
        if (state.mode === 'vrije' && segments.length === 0) addSegment();
        refreshAllGateSegmentOptions();
        recalc();
      });
    });
    rectWidthInput.addEventListener('input', function () { refreshAllGateSegmentOptions(); recalc(); });
    rectLengthInput.addEventListener('input', function () { refreshAllGateSegmentOptions(); recalc(); });
    linearLengthInput.addEventListener('input', recalc);
    linearCornersInput.addEventListener('input', recalc);

    // ---------------------------------------------------------------
    // Poort aan/uit
    // ---------------------------------------------------------------
    gateToggleButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.gateOn = btn.getAttribute('data-val') === 'yes';
        gateToggleButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        gatesWrap.hidden = !state.gateOn;
        if (state.gateOn && gates.length === 0) addGate();
        recalc();
      });
    });

    // ---------------------------------------------------------------
    // Meerdere poorten: elke poort-kaart = groep -> variant -> plaatsing
    // ---------------------------------------------------------------
    function getAvailableGateGroups() {
      return (active.gateGroups || []).filter(function (g) { return g.options && g.options.length; });
    }

    function addGate() {
      gateIdCounter++;
      var card = document.createElement('div');
      card.className = 'pk-calc__gate-card';
      card.innerHTML =
        '<div class="pk-calc__gate-card-header">' +
          '<span class="pk-calc__gate-card-title" data-pk-gate-title></span>' +
          '<button type="button" class="pk-calc__seg-remove" data-pk-gate-remove title="' + (t.removeGate || '') + '">\u00D7</button>' +
        '</div>' +
        '<div class="pk-calc__block">' +
          '<p class="pk-calc__label" data-pk-gate-group-label></p>' +
          '<div class="pk-calc__row-choice pk-calc__row-choice--full" data-pk-gate-group-choice></div>' +
        '</div>' +
        '<div class="pk-calc__block" data-pk-gate-dimension-block hidden>' +
          '<button type="button" class="pk-calc__accordion-toggle" data-pk-gate-dimension-toggle>' +
            '<span class="pk-calc__accordion-toggle-text">' +
              '<span data-pk-gate-dimension-label></span>' +
              '<span class="pk-calc__accordion-selected" data-pk-gate-dimension-selected></span>' +
            '</span>' +
            '<span class="pk-calc__accordion-chevron" aria-hidden="true"></span>' +
          '</button>' +
          '<div class="pk-calc__row-choice" data-pk-gate-dimension-choice></div>' +
        '</div>' +
        '<div class="pk-calc__block" data-pk-gate-position-block hidden>' +
          '<div class="pk-calc__inline-fields">' +
            '<div class="pk-calc__field pk-calc__field--num">' +
              '<label data-pk-gate-segment-label></label>' +
              '<select data-pk-gate-segment></select>' +
            '</div>' +
            '<div class="pk-calc__field pk-calc__field--num">' +
              '<label data-pk-gate-distance-label></label>' +
              '<input type="number" min="0" step="0.1" data-pk-gate-distance>' +
            '</div>' +
          '</div>' +
          '<p class="pk-calc__advice-text" data-pk-gate-no-fit hidden></p>' +
        '</div>';
      gatesListEl.appendChild(card);

      var gate = {
        id: gateIdCounter, groupIndex: null, item: null, segIdx: 0, dist: 0, dimensionOpen: true,
        els: {
          card: card,
          title: card.querySelector('[data-pk-gate-title]'),
          removeBtn: card.querySelector('[data-pk-gate-remove]'),
          groupLabel: card.querySelector('[data-pk-gate-group-label]'),
          groupChoice: card.querySelector('[data-pk-gate-group-choice]'),
          dimensionBlock: card.querySelector('[data-pk-gate-dimension-block]'),
          dimensionToggle: card.querySelector('[data-pk-gate-dimension-toggle]'),
          dimensionLabel: card.querySelector('[data-pk-gate-dimension-label]'),
          dimensionSelected: card.querySelector('[data-pk-gate-dimension-selected]'),
          dimensionChoice: card.querySelector('[data-pk-gate-dimension-choice]'),
          positionBlock: card.querySelector('[data-pk-gate-position-block]'),
          segmentLabel: card.querySelector('[data-pk-gate-segment-label]'),
          segmentSelect: card.querySelector('[data-pk-gate-segment]'),
          distanceLabel: card.querySelector('[data-pk-gate-distance-label]'),
          distanceInput: card.querySelector('[data-pk-gate-distance]'),
          noFit: card.querySelector('[data-pk-gate-no-fit]')
        }
      };

      gate.els.groupLabel.textContent = t.gateGroupLabel || '';
      gate.els.dimensionLabel.textContent = t.gateDimensionLabel || '';
      gate.els.segmentLabel.textContent = t.gateSegmentLabel || '';
      gate.els.distanceLabel.textContent = t.gateDistanceLabel || '';
      gate.els.noFit.textContent = t.gateNoFit || '';
      gate.els.removeBtn.addEventListener('click', function () { removeGate(gate); });
      gate.els.dimensionToggle.addEventListener('click', function () {
        gate.dimensionOpen = !gate.dimensionOpen;
        applyDimensionOpenState(gate);
      });
      gate.els.segmentSelect.addEventListener('change', function () {
        gate.segIdx = parseInt(gate.els.segmentSelect.value, 10) || 0;
        clampGateDistance(gate);
        recalc();
      });
      gate.els.distanceInput.addEventListener('input', function () {
        gate.dist = parseFloat(gate.els.distanceInput.value) || 0;
        clampGateDistance(gate);
        recalc();
      });

      gates.push(gate);
      renumberGates();
      rebuildGateGroupChoices(gate);
      return gate;
    }
    function removeGate(gate) {
      var idx = gates.indexOf(gate);
      if (idx === -1) return;
      gates.splice(idx, 1);
      gate.els.card.parentNode.removeChild(gate.els.card);
      renumberGates();
      recalc();
    }
    function renumberGates() {
      gates.forEach(function (g, i) {
        g.els.title.textContent = (t.gateNumber || 'Poort') + ' ' + (i + 1);
      });
    }
    addGateBtn.addEventListener('click', function () { addGate(); recalc(); });

    function rebuildGateGroupChoices(gate) {
      var groups = getAvailableGateGroups();
      gate.els.groupChoice.innerHTML = '';
      var btns = [];
      groups.forEach(function (grp) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pk-calc__row-choice-item';
        var thumbUrl = (grp.options[0] && grp.options[0].imageUrl) || '';
        if (thumbUrl) {
          var thumbWrap = document.createElement('span');
          thumbWrap.className = 'pk-calc__row-choice-thumb-wrap';
          var img = document.createElement('img');
          img.className = 'pk-calc__row-choice-thumb';
          img.src = thumbUrl;
          img.alt = '';
          img.loading = 'lazy';
          thumbWrap.appendChild(img);
          btn.appendChild(thumbWrap);
        } else {
          var noImg = document.createElement('span');
          noImg.className = 'pk-calc__row-choice-noimg';
          btn.appendChild(noImg);
        }
        var label = document.createElement('span');
        label.className = 'pk-calc__row-choice-label';
        label.textContent = grp.groupTitle || ('Optie ' + grp.groupIndex);
        btn.appendChild(label);
        btn.addEventListener('click', function () {
          gate.groupIndex = grp.groupIndex;
          gate.item = null;
          gate.dimensionOpen = true;
          btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          rebuildGateDimensionChoices(gate);
          recalc();
        });
        btns.push(btn);
        gate.els.groupChoice.appendChild(btn);
      });
      var stillValid = groups.some(function (grp) { return grp.groupIndex === gate.groupIndex; });
      if (!stillValid) { gate.groupIndex = null; gate.item = null; }
      btns.forEach(function (b, i) { b.classList.toggle('is-active', groups[i] && groups[i].groupIndex === gate.groupIndex); });
      rebuildGateDimensionChoices(gate);
    }

    function rebuildGateDimensionChoices(gate) {
      gate.els.dimensionChoice.innerHTML = '';
      if (gate.groupIndex == null) {
        gate.els.dimensionBlock.hidden = true;
        gate.els.positionBlock.hidden = true;
        return;
      }
      var grp = getAvailableGateGroups().filter(function (g) { return g.groupIndex === gate.groupIndex; })[0];
      var options = grp ? grp.options : [];
      if (options.length === 1) {
        gate.item = options[0];
        gate.els.dimensionBlock.hidden = true;
        refreshGateSegmentOptions(gate);
        return;
      }
      gate.els.dimensionBlock.hidden = false;
      var btns = [];
      options.forEach(function (opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pk-calc__row-choice-item';
        if (opt.imageUrl) {
          var thumbWrap = document.createElement('span');
          thumbWrap.className = 'pk-calc__row-choice-thumb-wrap';
          var img = document.createElement('img');
          img.className = 'pk-calc__row-choice-thumb';
          img.src = opt.imageUrl;
          img.alt = '';
          img.loading = 'lazy';
          thumbWrap.appendChild(img);
          btn.appendChild(thumbWrap);
        } else {
          var noImg = document.createElement('span');
          noImg.className = 'pk-calc__row-choice-noimg';
          btn.appendChild(noImg);
        }
        var label = document.createElement('span');
        label.className = 'pk-calc__row-choice-label';
        label.textContent = opt.title;
        btn.appendChild(label);
        btn.addEventListener('click', function () {
          gate.item = opt;
          btns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          refreshGateSegmentOptions(gate);
          // Klapt automatisch dicht na een keuze — bespaart ruimte, de
          // keuze blijft zichtbaar via de accordion-titel en de knop om
          // opnieuw te openen.
          gate.dimensionOpen = false;
          applyDimensionOpenState(gate);
          recalc();
        });
        if (gate.item && gate.item.variantId === opt.variantId) btn.classList.add('is-active');
        btns.push(btn);
        gate.els.dimensionChoice.appendChild(btn);
      });
      applyDimensionOpenState(gate);
    }

    // Open/dicht-status van de "Kies de afmeting"-lijst + toont welke
    // afmeting gekozen is naast de titel (blijft zichtbaar ook als de
    // lijst dichtgeklapt is).
    function applyDimensionOpenState(gate) {
      if (gate.els.dimensionSelected) {
        gate.els.dimensionSelected.textContent = gate.item ? ('— ' + gate.item.title) : '';
      }
      if (gate.els.dimensionChoice.children.length === 0) return;
      gate.els.dimensionChoice.hidden = !gate.dimensionOpen;
      gate.els.dimensionToggle.classList.toggle('is-open', gate.dimensionOpen);
    }

    function getGateWidthM(gate) {
      if (!gate.item || !gate.item.widthCm) return 0;
      return gate.item.widthCm / 100;
    }

    function refreshAllGateSegmentOptions() {
      gates.forEach(function (g) { refreshGateSegmentOptions(g); });
    }

    function refreshGateSegmentOptions(gate) {
      var widthM = getGateWidthM(gate);
      if (state.mode === 'lopende' || !widthM) {
        gate.els.positionBlock.hidden = true;
        return;
      }
      var segs = getEffectiveSegments();
      gate.els.segmentSelect.innerHTML = '';
      var validIdx = [];
      segs.list.forEach(function (s, i) {
        var fits = s.lengthM >= widthM - EPS;
        var opt = document.createElement('option');
        opt.value = i;
        opt.textContent = (t.segment || 'Segment') + ' ' + (i + 1) + ' (' + s.lengthM.toFixed(1) + ' m)';
        opt.disabled = !fits;
        gate.els.segmentSelect.appendChild(opt);
        if (fits) validIdx.push(i);
      });

      if (!validIdx.length) {
        gate.els.positionBlock.hidden = false;
        gate.els.segmentSelect.hidden = true;
        gate.els.distanceInput.closest('.pk-calc__field').hidden = true;
        gate.els.noFit.hidden = false;
        return;
      }

      gate.els.positionBlock.hidden = false;
      gate.els.segmentSelect.hidden = false;
      gate.els.distanceInput.closest('.pk-calc__field').hidden = false;
      gate.els.noFit.hidden = true;

      if (validIdx.indexOf(gate.segIdx) === -1) gate.segIdx = validIdx[0];
      gate.els.segmentSelect.value = gate.segIdx;
      clampGateDistance(gate);
    }

    function clampGateDistance(gate) {
      var segs = getEffectiveSegments();
      var seg = segs.list[gate.segIdx];
      var widthM = getGateWidthM(gate);
      if (!seg || !widthM) return;
      var maxDist = Math.max(0, seg.lengthM - widthM);
      if (gate.dist > maxDist) gate.dist = maxDist;
      if (gate.dist < 0) gate.dist = 0;
      gate.els.distanceInput.max = maxDist.toFixed(2);
      gate.els.distanceInput.value = gate.dist;
    }

    function getActiveGatePlacements() {
      // Enkel poorten met een geldige, passende plaatsing worden meegeteld.
      if (state.mode === 'lopende') return [];
      var segs = getEffectiveSegments();
      var placements = [];
      gates.forEach(function (gate) {
        var widthM = getGateWidthM(gate);
        if (!widthM) return;
        var seg = segs.list[gate.segIdx];
        if (!seg || seg.lengthM < widthM - EPS) return;
        var maxDist = Math.max(0, seg.lengthM - widthM);
        var distStart = Math.max(0, Math.min(gate.dist || 0, maxDist));
        var distEnd = distStart + widthM;
        placements.push({ gate: gate, item: gate.item, segIdx: gate.segIdx, widthM: widthM, distStart: distStart, distEnd: distEnd });
      });
      return placements;
    }

    // ---------------------------------------------------------------
    // Geometrie (identiek principe aan de hek-calculator)
    // ---------------------------------------------------------------
    function walkPoints(list) {
      var heading = 0;
      var pts = [{ x: 0, y: 0 }];
      list.forEach(function (seg, i) {
        if (i > 0) heading += (seg.angleDeg * Math.PI) / 180;
        var last = pts[pts.length - 1];
        pts.push({ x: last.x + seg.lengthM * Math.cos(heading), y: last.y + seg.lengthM * Math.sin(heading) });
      });
      return { pts: pts, endHeading: heading };
    }

    function computeClosingSegment(list) {
      if (!list.length) return null;
      var walked = walkPoints(list);
      var last = walked.pts[walked.pts.length - 1];
      var dx = -last.x, dy = -last.y;
      var dist = Math.sqrt(dx * dx + dy * dy);
      if (dist < EPS) return null;
      var targetHeading = Math.atan2(dy, dx);
      var turnDeg = (targetHeading - walked.endHeading) * 180 / Math.PI;
      while (turnDeg > 180) turnDeg -= 360;
      while (turnDeg < -180) turnDeg += 360;
      return { lengthM: dist, angleDeg: turnDeg };
    }

    function getEffectiveSegments() {
      if (state.mode === 'rechthoek') {
        var w = parseFloat(rectWidthInput.value) || 0;
        var l = parseFloat(rectLengthInput.value) || 0;
        if (w <= 0 || l <= 0) return { list: [], closed: true };
        return { list: [{ lengthM: w, angleDeg: 0 }, { lengthM: l, angleDeg: 90 }, { lengthM: w, angleDeg: 90 }, { lengthM: l, angleDeg: 90 }], closed: true };
      }
      if (state.mode === 'vrije') {
        var list = segments
          .map(function (s, i) { return { lengthM: parseFloat(s.lengthInput.value) || 0, angleDeg: i === 0 ? 0 : (parseFloat(s.angleInput.value) || 0) }; })
          .filter(function (s) { return s.lengthM > 0; });
        if (closeLoopOn && list.length) {
          var closer = computeClosingSegment(list);
          if (closer) list = list.concat([closer]);
        }
        return { list: list, closed: closeLoopOn };
      }
      return { list: [], closed: false };
    }

    // ---------------------------------------------------------------
    // Liggers + palen rekenwerk over de volledige vorm, rekening houdend
    // met 0, 1 of meerdere poorten per stuk.
    // ---------------------------------------------------------------
    function computeFence(segList, closed, gatePlacements) {
      var n = segList.length;
      if (!n) return null;
      var vertexCount = closed ? n : n + 1;
      var spanLenM = liggerLengthM();
      if (!spanLenM || spanLenM <= 0) return null;

      var gatesBySeg = {};
      gatePlacements.forEach(function (g) {
        (gatesBySeg[g.segIdx] = gatesBySeg[g.segIdx] || []).push(g);
      });
      Object.keys(gatesBySeg).forEach(function (k) {
        gatesBySeg[k].sort(function (a, b) { return a.distStart - b.distStart; });
      });

      var totalSpans = 0;
      var interiorTussenpalen = 0;
      var absorbedVertices = {};
      var segPiecesForDrawing = [];

      segList.forEach(function (seg, i) {
        var segGates = gatesBySeg[i] || [];
        var cursor = 0;
        var pieces = [];
        segGates.forEach(function (g) {
          var pieceLen = g.distStart - cursor;
          if (pieceLen > EPS) pieces.push({ type: 'fence', lengthM: pieceLen, fromM: cursor, toM: g.distStart });
          pieces.push({ type: 'gate', lengthM: g.widthM, fromM: g.distStart, toM: g.distEnd, gate: g });
          cursor = g.distEnd;
        });
        var tailLen = seg.lengthM - cursor;
        if (tailLen > EPS || pieces.length === 0) {
          pieces.push({ type: 'fence', lengthM: Math.max(0, tailLen), fromM: cursor, toM: seg.lengthM });
        }

        if (segGates.length) {
          var first = segGates[0], last = segGates[segGates.length - 1];
          if (first.distStart <= EPS) absorbedVertices[i] = true;
          var endVertexIdx = closed ? (i + 1) % n : i + 1;
          if ((seg.lengthM - last.distEnd) <= EPS) absorbedVertices[endVertexIdx] = true;
        }

        pieces.forEach(function (p) {
          if (p.type === 'fence' && p.lengthM > EPS) {
            var spans = Math.ceil((p.lengthM - EPS) / spanLenM);
            totalSpans += spans;
            interiorTussenpalen += Math.max(0, spans - 1);
          }
        });

        segPiecesForDrawing.push({ segIdx: i, pieces: pieces });
      });

      var hoekpuntCount = 0, eindpuntCount = 0;
      for (var v = 0; v < vertexCount; v++) {
        if (absorbedVertices[v]) continue;
        var isTrueEnd = !closed && (v === 0 || v === n);
        if (isTrueEnd) eindpuntCount++; else hoekpuntCount++;
      }

      var totalLengthM = segList.reduce(function (s, seg) { return s + seg.lengthM; }, 0);
      gatePlacements.forEach(function (g) { totalLengthM -= g.widthM; });

      return {
        liggersNeeded: totalSpans * (active.aantalLiggers || 0),
        tussenpalenBase: interiorTussenpalen,
        hoekpuntCount: hoekpuntCount,
        eindpuntCount: eindpuntCount,
        totalLengthM: totalLengthM,
        segPiecesForDrawing: segPiecesForDrawing
      };
    }

    // Vertaal hoekpunt/eindpunt-tellingen naar echte productcategorieën,
    // rekening houdend met de fallback-regels wanneer hoekpaal/eindpaal
    // niet gekoppeld zijn aan het metaobject.
    function resolvePolesFromCounts(fenceResult) {
      var hoekpalen = 0, eindpalen = 0, tussenpalen = fenceResult.tussenpalenBase;
      if (active.hasHoekpaal) {
        hoekpalen = fenceResult.hoekpuntCount;
      } else {
        tussenpalen += fenceResult.hoekpuntCount * 2;
      }
      if (active.hasEindpaal) {
        eindpalen = fenceResult.eindpuntCount;
      } else {
        tussenpalen += fenceResult.eindpuntCount;
      }
      return { hoekpalen: hoekpalen, eindpalen: eindpalen, tussenpalen: tussenpalen };
    }

    // ---------------------------------------------------------------
    // Tekening
    // ---------------------------------------------------------------
    function drawFence(segList, closed, fenceResult) {
      drawingContent.innerHTML = '';
      if (!segList.length || !fenceResult) { drawingNote.setAttribute('opacity', '0'); return; }

      var pts = walkPoints(segList).pts;
      var viewW = 600, viewH = 320, pad = 44;
      var xs = pts.map(function (p) { return p.x; }), ys = pts.map(function (p) { return p.y; });
      var minX = Math.min.apply(null, xs), maxX = Math.max.apply(null, xs);
      var minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
      var spanX = Math.max(maxX - minX, 0.01), spanY = Math.max(maxY - minY, 0.01);
      var scale = Math.min((viewW - pad * 2) / spanX, (viewH - pad * 2) / spanY);
      var offsetX = pad + (viewW - pad * 2 - spanX * scale) / 2 - minX * scale;
      var offsetY = pad + (viewH - pad * 2 - spanY * scale) / 2 - minY * scale;
      function toSvg(p) { return { x: p.x * scale + offsetX, y: p.y * scale + offsetY }; }
      function lerp(a, b, frac) { return { x: a.x + (b.x - a.x) * frac, y: a.y + (b.y - a.y) * frac }; }

      function drawFencePiece(aModel, bModel, lenM, showLabel) {
        var a = toSvg(aModel), b = toSvg(bModel);
        var line = document.createElementNS(SVG_NS, 'line');
        line.setAttribute('x1', a.x); line.setAttribute('y1', a.y);
        line.setAttribute('x2', b.x); line.setAttribute('y2', b.y);
        line.setAttribute('stroke', '#e87722'); line.setAttribute('stroke-width', '3');
        drawingContent.appendChild(line);

        var dx = b.x - a.x, dy = b.y - a.y, len = Math.sqrt(dx * dx + dy * dy) || 1;
        if (showLabel) {
          var mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
          var nx = -dy / len, ny = dx / len;
          var label = document.createElementNS(SVG_NS, 'text');
          label.setAttribute('x', mx + nx * 12); label.setAttribute('y', my + ny * 12);
          label.setAttribute('text-anchor', 'middle'); label.setAttribute('font-size', '11'); label.setAttribute('fill', '#444');
          label.textContent = (Math.round(lenM * 100) / 100) + ' m';
          drawingContent.appendChild(label);
        }

        var spanLenM = liggerLengthM();
        if (state.polesOn && lenM > EPS && spanLenM > 0) {
          var spans = Math.ceil((lenM - EPS) / spanLenM);
          var tussenCount = Math.max(0, spans - 1);
          for (var k = 1; k <= tussenCount; k++) {
            var frac = k / (tussenCount + 1);
            var xx = a.x + dx * frac, yy = a.y + dy * frac;
            var xmark = document.createElementNS(SVG_NS, 'text');
            xmark.setAttribute('x', xx); xmark.setAttribute('y', yy + 4);
            xmark.setAttribute('text-anchor', 'middle'); xmark.setAttribute('font-size', '11'); xmark.setAttribute('fill', '#3a9b3a');
            xmark.textContent = '\u00D7';
            drawingContent.appendChild(xmark);
          }
        }
      }

      function drawGateZone(startSvg, endSvg, label) {
        var line = document.createElementNS(SVG_NS, 'line');
        line.setAttribute('x1', startSvg.x); line.setAttribute('y1', startSvg.y);
        line.setAttribute('x2', endSvg.x); line.setAttribute('y2', endSvg.y);
        line.setAttribute('stroke', '#2d2d2d'); line.setAttribute('stroke-width', '5'); line.setAttribute('stroke-dasharray', '2 3');
        drawingContent.appendChild(line);
        var mx = (startSvg.x + endSvg.x) / 2, my = (startSvg.y + endSvg.y) / 2;
        var lbl = document.createElementNS(SVG_NS, 'text');
        lbl.setAttribute('x', mx); lbl.setAttribute('y', my - 10);
        lbl.setAttribute('text-anchor', 'middle'); lbl.setAttribute('font-size', '10'); lbl.setAttribute('font-weight', '700'); lbl.setAttribute('fill', '#2d2d2d');
        lbl.textContent = label;
        drawingContent.appendChild(lbl);
      }

      function drawPostMarker(sp) {
        var sq = document.createElementNS(SVG_NS, 'rect');
        sq.setAttribute('x', sp.x - 5); sq.setAttribute('y', sp.y - 5);
        sq.setAttribute('width', 10); sq.setAttribute('height', 10);
        sq.setAttribute('fill', '#2d2d2d'); sq.setAttribute('stroke', '#2d2d2d'); sq.setAttribute('stroke-width', '1');
        drawingContent.appendChild(sq);
      }

      var skipVertexCircle = {};

      fenceResult.segPiecesForDrawing.forEach(function (segEntry) {
        var i = segEntry.segIdx;
        var aModel = pts[i], bModel = pts[i + 1];
        var segLenM = segList[i].lengthM;
        segEntry.pieces.forEach(function (p) {
          var fromModel = lerp(aModel, bModel, segLenM > 0 ? p.fromM / segLenM : 0);
          var toModel = lerp(aModel, bModel, segLenM > 0 ? p.toM / segLenM : 0);
          if (p.type === 'fence') {
            if (p.lengthM > EPS) drawFencePiece(fromModel, toModel, p.lengthM, true);
          } else {
            drawGateZone(toSvg(fromModel), toSvg(toModel), t.gateLineLabel || 'Poort');
            drawPostMarker(toSvg(fromModel));
            drawPostMarker(toSvg(toModel));
            if (p.fromM <= EPS) skipVertexCircle[i] = true;
            var endVertexIdx = closed ? (i + 1) % segList.length : i + 1;
            if ((segLenM - p.toM) <= EPS) skipVertexCircle[endVertexIdx] = true;
          }
        });
      });

      pts.forEach(function (p, i) {
        if (closed && i === pts.length - 1) return;
        if (skipVertexCircle[i]) return;
        var sp = toSvg(p);
        var isTrueEnd = !closed && (i === 0 || i === pts.length - 1);
        var circle = document.createElementNS(SVG_NS, 'circle');
        circle.setAttribute('cx', sp.x); circle.setAttribute('cy', sp.y);
        circle.setAttribute('r', isTrueEnd ? 6 : 4.5);
        circle.setAttribute('fill', isTrueEnd ? '#e87722' : '#fff');
        circle.setAttribute('stroke', isTrueEnd ? '#e87722' : '#7CB139');
        circle.setAttribute('stroke-width', '2');
        drawingContent.appendChild(circle);
        if (isTrueEnd) {
          var lbl = document.createElementNS(SVG_NS, 'text');
          lbl.setAttribute('x', sp.x); lbl.setAttribute('y', sp.y - 12);
          lbl.setAttribute('text-anchor', 'middle'); lbl.setAttribute('font-size', '10'); lbl.setAttribute('font-weight', '700'); lbl.setAttribute('fill', '#e87722');
          lbl.textContent = i === 0 ? (t.begin || 'Begin') : (t.end || 'Eind');
          drawingContent.appendChild(lbl);
        }
      });

      drawingNote.setAttribute('opacity', '1');
    }

    // ---------------------------------------------------------------
    // Aannemer-prijs sync — identiek aan de hek-calculator.
    // ---------------------------------------------------------------
    var proPriceCache = {};
    var proSyncPending = {};
    var proSyncQueue = [];
    var proSyncInFlight = false;
    var proSyncContainer = null;

    function getProSyncContainer() {
      if (!proSyncContainer) {
        proSyncContainer = document.createElement('div');
        proSyncContainer.setAttribute('aria-hidden', 'true');
        proSyncContainer.style.cssText = 'position:absolute; width:1px; height:1px; overflow:hidden; clip:rect(0,0,0,0); left:-9999px; top:0;';
        document.body.appendChild(proSyncContainer);
      }
      return proSyncContainer;
    }

    function requestProSync(item) {
      if (!item || !item.variantId || !item.productUrl || !item.productId) return;
      if (proPriceCache[item.variantId] != null) return;
      if (proSyncPending[item.variantId]) return;
      proSyncPending[item.variantId] = true;
      proSyncQueue.push(item);
      processProSyncQueue();
    }
    function processProSyncQueue() {
      if (proSyncInFlight || !proSyncQueue.length) return;
      proSyncInFlight = true;
      var item = proSyncQueue.shift();
      syncOneProPrice(item, function () {
        proSyncInFlight = false;
        processProSyncQueue();
      });
    }
    function syncOneProPrice(item, done) {
      var sectionEl = document.querySelector('[data-section-type="product"]');
      var sectionId = sectionEl ? sectionEl.getAttribute('data-section-id') : null;
      if (!sectionId) { done(); return; }
      var url = item.productUrl + '?variant=' + item.variantId + '&section_id=' + sectionId;
      var finished = false;
      function finish() { if (finished) return; finished = true; done(); }

      fetch(url).then(function (res) { return res.text(); }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.getElementById('product-price-' + item.productId);
        if (!fresh) { finish(); return; }

        var container = getProSyncContainer();
        container.innerHTML = fresh.innerHTML;
        container.querySelectorAll('script').forEach(function (oldScript) {
          var newScript = document.createElement('script');
          if (oldScript.src) newScript.src = oldScript.src; else newScript.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });

        var attempts = 0, maxAttempts = 20;
        var poll = setInterval(function () {
          attempts++;
          var priceEl = container.querySelector('.wpd-tax-excl-price');
          if (priceEl && priceEl.textContent && priceEl.textContent.trim()) {
            var textVal = priceEl.textContent || '';
            var num = parseFloat(textVal.replace(/[^\d,.-]/g, '').replace(',', '.'));
            if (num) { proPriceCache[item.variantId] = Math.round(num * 100); recalc(); }
            clearInterval(poll);
            finish();
          } else if (attempts >= maxAttempts) {
            clearInterval(poll);
            finish();
          }
        }, 300);
      }).catch(function () { finish(); });
    }

    // ---------------------------------------------------------------
    // Recalc
    // ---------------------------------------------------------------
    function recalc() {
      var liggersNeeded = 0, hoekpalen = 0, tussenpalen = 0, eindpalen = 0, totalLengthM = 0;
      var activeGatePlacements = [];

      if (state.mode === 'lopende') {
        drawingWrap.hidden = true;
        drawingPlaceholder.hidden = false;
        drawingPlaceholder.textContent = t.schematicNote || '';
        totalLengthM = parseFloat(linearLengthInput.value) || 0;
        var spanLenM = liggerLengthM();
        if (totalLengthM > 0 && spanLenM > 0) {
          var spans = Math.ceil((totalLengthM - EPS) / spanLenM);
          liggersNeeded = spans * (active.aantalLiggers || 0);
          if (state.polesOn) {
            var corners = parseInt(linearCornersInput.value, 10) || 0;
            if (active.hasHoekpaal) { hoekpalen = corners; } else { tussenpalen += corners * 2; }
            if (active.hasEindpaal) { eindpalen = 2; } else { tussenpalen += 2; }
            tussenpalen += Math.max(0, spans - 1);
          }
        }
        // Poorten zijn enkel beschikbaar bij Rechthoek/Vrije vorm (nodig om
        // een zijde + positie te kunnen kiezen) — analoog aan de hek-calculator.
      } else {
        drawingWrap.hidden = false;
        drawingPlaceholder.hidden = true;
        var eff = getEffectiveSegments();
        activeGatePlacements = state.gateOn ? getActiveGatePlacements() : [];
        var fenceResult = computeFence(eff.list, eff.closed, activeGatePlacements);
        drawFence(eff.list, eff.closed, fenceResult);
        if (fenceResult) {
          totalLengthM = fenceResult.totalLengthM;
          liggersNeeded = fenceResult.liggersNeeded;
          if (state.polesOn) {
            var resolved = resolvePolesFromCounts(fenceResult);
            hoekpalen = resolved.hoekpalen;
            tussenpalen = resolved.tussenpalen;
            eindpalen = resolved.eindpalen;
          }
        }
      }

      gateQuestion.hidden = totalLengthM <= 0 || state.mode === 'lopende';
      if (state.mode === 'lopende' && state.gateOn) {
        // Poort niet mogelijk in deze modus: forceer uit.
        state.gateOn = false;
        gateToggleButtons.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-val') === 'no'); });
        gatesWrap.hidden = true;
      }

      if (totalLengthM <= 0) {
        resultsEl.hidden = true;
        breakdownEl.innerHTML = '';
        addToCartBtn.disabled = true;
        lastCalc = null;
        updateGateBundles();
        return;
      }

      var gateLines = activeGatePlacements.filter(function (g) { return g.item; }).map(function (g) { return g.item; });

      var totalCents = liggersNeeded * (active.ligger.priceCents || 0);
      if (state.polesOn) {
        totalCents += hoekpalen * (active.hoekpaal.priceCents || 0)
          + tussenpalen * (active.tussenpaal.priceCents || 0)
          + eindpalen * (active.eindpaal.priceCents || 0);
      }
      gateLines.forEach(function (item) { totalCents += item.priceCents || 0; });

      lastCalc = {
        liggersNeeded: liggersNeeded, hoekpalen: hoekpalen, tussenpalen: tussenpalen, eindpalen: eindpalen,
        gateLines: gateLines, totalCents: totalCents
      };

      renderBreakdown();
      resultsEl.hidden = false;
      addToCartBtn.disabled = false;

      if (data.isProfessional) {
        requestProSync(active.ligger);
        if (state.polesOn) {
          if (hoekpalen > 0) requestProSync(active.hoekpaal);
          if (tussenpalen > 0) requestProSync(active.tussenpaal);
          if (eindpalen > 0) requestProSync(active.eindpaal);
        }
        gateLines.forEach(function (item) { requestProSync(item); });
      }

      updateGateBundles();
    }

    function renderBreakdown() {
      breakdownEl.innerHTML = '';
      function addRow(container, labelText, qty, unitCents, titleText, strike, imageUrl) {
        var row = document.createElement('div');
        row.className = 'pk-calc__row' + (strike ? ' pk-calc__row--strike' : '');
        var thumb = imageUrl ? ('<img class="pk-calc__row-thumb" src="' + imageUrl + '" alt="">') : '';
        var left = titleText ? (thumb + qty + ' ' + (t.pieces || 'x') + ' ' + labelText + ' <span class="pk-calc__row-sub">(' + titleText + ')</span>') : (thumb + qty + ' ' + (t.pieces || 'x') + ' ' + labelText);
        row.innerHTML = '<span>' + left + '</span><strong>' + money(qty * (unitCents || 0)) + '</strong>';
        container.appendChild(row);
      }

      addRow(breakdownEl, t.liggersLabel, lastCalc.liggersNeeded, active.ligger.priceCents, active.ligger.title, data.isProfessional);
      if (state.polesOn) {
        if (lastCalc.hoekpalen > 0) addRow(breakdownEl, t.hoekpalenLabel, lastCalc.hoekpalen, active.hoekpaal.priceCents, active.hoekpaal.title, data.isProfessional);
        if (lastCalc.tussenpalen > 0) addRow(breakdownEl, t.tussenpalenLabel, lastCalc.tussenpalen, active.tussenpaal.priceCents, active.tussenpaal.title, data.isProfessional);
        if (lastCalc.eindpalen > 0) addRow(breakdownEl, t.eindpalenLabel, lastCalc.eindpalen, active.eindpaal.priceCents, active.eindpaal.title, data.isProfessional);
      }
      lastCalc.gateLines.forEach(function (item) {
        addRow(breakdownEl, t.gateLineLabel, 1, item.priceCents, (item.fullTitle || item.title), data.isProfessional);
      });

      var totalRow = document.createElement('div');
      totalRow.className = 'pk-calc__row pk-calc__row--total' + (data.isProfessional ? ' pk-calc__row--strike' : '');
      totalRow.innerHTML = '<span>' + (t.totalLabel || '') + '</span><strong>' + money(lastCalc.totalCents) + '</strong>';
      breakdownEl.appendChild(totalRow);

      if (!data.isProfessional) { proBreakdownEl.hidden = true; return; }

      var neededIds = [active.ligger.variantId];
      if (state.polesOn) {
        if (lastCalc.hoekpalen > 0) neededIds.push(active.hoekpaal.variantId);
        if (lastCalc.tussenpalen > 0) neededIds.push(active.tussenpaal.variantId);
        if (lastCalc.eindpalen > 0) neededIds.push(active.eindpaal.variantId);
      }
      lastCalc.gateLines.forEach(function (item) { neededIds.push(item.variantId); });

      var allReady = neededIds.every(function (id) { return proPriceCache[id] != null; });
      if (!allReady) { proBreakdownEl.hidden = true; return; }

      proBreakdownEl.innerHTML = '';
      var proTitle = document.createElement('p');
      proTitle.className = 'pk-calc__row-group-title';
      proTitle.textContent = t.proGroupTitle || '';
      proBreakdownEl.appendChild(proTitle);

      var proTotalCents = 0;
      function addProRow(qty, variantId, labelText, titleText, imageUrl) {
        var unitCents = proPriceCache[variantId];
        proTotalCents += qty * unitCents;
        addRow(proBreakdownEl, labelText, qty, unitCents, titleText, false, imageUrl);
      }
      addProRow(lastCalc.liggersNeeded, active.ligger.variantId, t.liggersLabel, active.ligger.title);
      if (state.polesOn) {
        if (lastCalc.hoekpalen > 0) addProRow(lastCalc.hoekpalen, active.hoekpaal.variantId, t.hoekpalenLabel, active.hoekpaal.title);
        if (lastCalc.tussenpalen > 0) addProRow(lastCalc.tussenpalen, active.tussenpaal.variantId, t.tussenpalenLabel, active.tussenpaal.title);
        if (lastCalc.eindpalen > 0) addProRow(lastCalc.eindpalen, active.eindpaal.variantId, t.eindpalenLabel, active.eindpaal.title);
      }
      lastCalc.gateLines.forEach(function (item) { addProRow(1, item.variantId, t.gateLineLabel, (item.fullTitle || item.title)); });

      var proTotalRow = document.createElement('div');
      proTotalRow.className = 'pk-calc__row pk-calc__row--total';
      proTotalRow.innerHTML = '<span>' + (t.totalProLabel || '') + '</span><strong>' + money(proTotalCents) + ' ' + (t.exclVat || '') + '</strong>';
      proBreakdownEl.appendChild(proTotalRow);

      proBreakdownEl.hidden = false;
    }

    function addToCart() {
      if (!lastCalc) return;
      var items = [{ id: active.ligger.variantId, quantity: lastCalc.liggersNeeded }];
      if (state.polesOn) {
        if (lastCalc.hoekpalen > 0) items.push({ id: active.hoekpaal.variantId, quantity: lastCalc.hoekpalen });
        if (lastCalc.tussenpalen > 0) items.push({ id: active.tussenpaal.variantId, quantity: lastCalc.tussenpalen });
        if (lastCalc.eindpalen > 0) items.push({ id: active.eindpaal.variantId, quantity: lastCalc.eindpalen });
      }
      lastCalc.gateLines.forEach(function (item) { items.push({ id: item.variantId, quantity: 1 }); });
      items = items.filter(function (item) { return item.quantity > 0 && item.id; });

      cartMsg.className = 'pk-calc__cart-msg';
      cartMsg.textContent = t.adding || '';
      addToCartBtn.disabled = true;

      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (res) { if (!res.ok) throw new Error('Cart add failed'); return res.json(); })
        .then(function () { cartMsg.textContent = t.added || ''; addToCartBtn.disabled = false; })
        .catch(function (err) {
          console.error(err);
          cartMsg.className = 'pk-calc__cart-msg pk-calc__cart-msg--error';
          cartMsg.textContent = t.error || '';
          addToCartBtn.disabled = false;
        });
    }
    addToCartBtn.addEventListener('click', addToCart);

    // ---------------------------------------------------------------
    // Init
    // ---------------------------------------------------------------
    addSegment();
    recalc();
  }

  return { init: init };
})();